export default __webpack_public_path__ + "static/media/x.dbc3a9b1.svg";